/**
 * Promo Banner — tracking impression + click.
 * Caricato UNA volta da snippets/section.main-collection.liquid (solo se esistono banner).
 * Idempotente: guardie globali e per-elemento. L'hover è gestito in CSS.
 */
(function () {
  if (window.__promoBannerInit) return;
  window.__promoBannerInit = true;

  var tracking = (window.promoBannerTracking = window.promoBannerTracking || {
    impressions: [],
    clicks: []
  });

  function sendImpression(banner) {
    if (banner.dataset.pbTracked) return;
    banner.dataset.pbTracked = '1';

    var title = banner.dataset.bannerTitle || 'Unknown';
    tracking.impressions.push({
      title: title,
      timestamp: new Date().toISOString(),
      url: window.location.href
    });

    if (typeof gtag !== 'undefined') {
      gtag('event', 'promo_banner_impression', {
        banner_title: title,
        page_url: window.location.href
      });
    }
    if (typeof fbq !== 'undefined') {
      fbq('trackCustom', 'PromoBannerImpression', { banner_title: title });
    }
    console.log('[Promo Banner] Impression tracked:', title);
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sendImpression(entry.target);
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.5 })
    : null;

  function observe(root) {
    (root || document).querySelectorAll('[data-promo-banner]').forEach(function (banner) {
      if (banner.dataset.pbObserved) return;
      banner.dataset.pbObserved = '1';
      if (io) {
        io.observe(banner);
      } else {
        sendImpression(banner);
      }
    });
  }

  // Click tracking via event delegation: sopravvive ai re-render AJAX dei filtri
  document.addEventListener('click', function (e) {
    var link = e.target.closest ? e.target.closest('[data-banner-click]') : null;
    if (!link) return;

    var banner = link.closest('[data-promo-banner]');
    if (!banner) return;

    var title = banner.dataset.bannerTitle || 'Unknown';
    var url = link.href;
    tracking.clicks.push({
      title: title,
      url: url,
      timestamp: new Date().toISOString(),
      sourceUrl: window.location.href
    });

    if (typeof gtag !== 'undefined') {
      gtag('event', 'promo_banner_click', {
        banner_title: title,
        banner_url: url,
        page_url: window.location.href
      });
    }
    if (typeof fbq !== 'undefined') {
      fbq('trackCustom', 'PromoBannerClick', { banner_title: title, banner_url: url });
    }
    console.log('[Promo Banner] Click tracked:', title, '→', url);
  });

  // Re-osserva i banner dopo i re-render della griglia (filtri AJAX)
  var mo = 'MutationObserver' in window
    ? new MutationObserver(function () { observe(document); })
    : null;

  function start() {
    observe(document);
    if (mo) {
      var grid = document.querySelector('.collection-grid') || document.body;
      mo.observe(grid, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  window.PromoBanner = { observe: observe };
})();
